import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, IconButton } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import * as R from 'ramda'
import _ from 'lodash'
import P from 'helpers/predicates'
import T from 'i18n-react'

import ConfigValidationTooltip from 'components/custom/ConfigValidationTooltip/index'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import Input from 'components/fulcrum/input/NumberInput'
import RangeInput from 'components/fulcrum/input/RangeInput'
import ConfigTable from './ConfigTable/index'
import { RENDER_EXTRA_INPUT } from './constants'

import styles from './styles.scss'

import {TableCell} from 'react-toolbox/lib/table'

class VoltageConfigItem extends Component {
  onPhaseCountChange = (index, part, railType) => {
    const phaseCountIdOrIndex = _.has(part, 'id') ? part.id : index
    return value => this.props.onUpdatePhaseCount(phaseCountIdOrIndex, railType, parseInt(value),_.has(part, 'id') )
  }

  onEfficiencyChange = (index, part, railType) => {
    const efficiencyIdOrIndex = _.has(part, 'id') ? part.id : index
    return value => this.props.onUpdateEfficiency(efficiencyIdOrIndex, railType, parseFloat(value), _.has(part, 'id'))
  }

  /**
   *
   * Generate the parts with existing data and delete icon.
   *
   * @param {Object[]} parts
   * @returns {Object[]} new array of parts with delete icon
   * @memberof VoltageConfigItem
   */
  generatePart(parts) {
    return parts.map(({...part}, index) => {
      // only show the input box for phase count if there exists a value
      const phaseCountInput = P.isNotNil(part) ? <Input
                                          value={ part.phaseCount ? part.phaseCount : '' }
                                          onChange={ this.onPhaseCountChange(index, part, part.railType) }
                                          hint='Input phase count value'
                                        /> : null
      const efficiencyInput = <RangeInput 
                                value={ part.efficiency ? part.efficiency : '' } 
                                min={0}
                                max={100}
                                onChange={ this.onEfficiencyChange(index, part, part.railType) }  
                                hint='Input VR Efficiency (%)' 
                              />
      return {
        ...part,
        phaseCountInput: phaseCountInput,
        efficiencyInput: efficiencyInput
      }
    })
  }

  render() {
    const {
      config,
      index,
      curPart,
      filterStatus,
      edpPeak,
      edpContinuous,
      outputVoltage,
      initFilters,
      onDeletePart,
      togglePopup,
      onTogglePopup,
      onUpdateCurConfig,
      onUpdateEdpPeak,
      onUpdateEdpContinuous,
      onUpdateOutputVoltage,
      setEditPart,
      isEdit,
      setIsAddPart,
      isAddPart
    } = this.props
    let configSource = this.generatePart(curPart)

    // const PartModel = {
    //   vendorName: {type: String, title: 'Vendor Name'},
    //   partNumber: {type: String, title: 'Part Number'},
    //   partType: {type: String, title: 'Part Type'},
    //   phaseCountInput: {header:<Input />, title: 'Phase Count'},
    // }

    const tableHeadContent = {
        vendorName: (<TableCell key={0}>Vendor Name</TableCell>),
        partNumber: (<TableCell key={1}>Part Number</TableCell>),
        partType: (<TableCell key={2}>Part Type</TableCell>),
        phaseCountInput: (<TableCell key={3}>Phase Count</TableCell>),
        efficiencyInput: (<TableCell key={4}>VR Efficiency</TableCell>),
    }

    const onEditRail = (id) => {
      setEditPart(id)
      const addConfig = _.pick(configSource[0], ['railType'])
      initFilters(filterStatus, addConfig)
      onTogglePopup()
      onUpdateCurConfig(addConfig)
    }

    return (
      <div key={index}>
        <div>
          <span styleName='configTitle'>{ config.railType }</span>
          <ConfigValidationTooltip
            isRisk={curPart ? curPart[0].risk === 'Risk' : false}
          />
          <p class={styles.subHeading}>Voltage Regulator</p>
        </div>
        <ConfigTable
          tableHeadContent={tableHeadContent}
          createAddBtn={ true }
          createEditBtn={ true }
          onEdit={ onEditRail }
          configSource={ configSource }
          configKeys={['railType']}
          filters={ filterStatus }
          initFilters={ initFilters }
          onDeletePart={ onDeletePart }
          onTogglePopup={ onTogglePopup }
          onUpdateCurConfig={ onUpdateCurConfig }
          btnText = {"Add Field"}
          isEdit={isEdit}
          setEditPart={setEditPart}
          deletable
          setIsAddPart={setIsAddPart}
          isAddPart={isAddPart}
        />
        {/* { config.railType === RENDER_EXTRA_INPUT &&
          <div>
            <FormTitle title={T.translate('notebook_project_creation.custom.edp_peak')}>
              <Input
                value={edpPeak ? edpPeak : ''}
                onChange={onUpdateEdpPeak}
                hint={T.translate('notebook_project_creation.custom_default_value.voltage_regulator_edp_peak')}
              />
            </FormTitle>
            <FormTitle title={T.translate('notebook_project_creation.custom.edp_continuous')}>
              <Input
                value={edpContinuous ? edpContinuous : ''}
                onChange={onUpdateEdpContinuous}
                hint={T.translate('notebook_project_creation.custom_default_value.voltage_regulator_edp_continuous')}
              />
            </FormTitle>
            <FormTitle title={T.translate('notebook_project_creation.custom.output_voltage')}>
              <Input
                value={outputVoltage ? outputVoltage : ''}
                onChange={onUpdateOutputVoltage}
                hint={T.translate('notebook_project_creation.custom_default_value.voltage_regulator_output_voltage')}
              />
            </FormTitle>
          </div>
        } */}
      </div>
    )
  }
}

VoltageConfigItem.propTypes = {
  index: PropTypes.number.isRequired,
  curPart: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,

  onTogglePopup: PropTypes.func.isRequired,
  onDeletePart: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(VoltageConfigItem, styles)
